import React, { Component } from 'react';
import classNames from 'classnames';
import SpinnerDots from '../spinner/dots';
import Takeover from '../takeover';
import { Link } from 'react-router-dom';
import './styles.scss';

class MyDelfi extends Component {
    
    state = {
        isOpen: false
    }

    toggleInfoAccount(type) {
        this.setState({
            isOpen: !this.state.isOpen,
            type
        });
    }

    getHeading() {
        switch(this.state.type) {
            case 'register':
                return 'Mitt Delfiregister';
            case 'salesdistricts':
                return 'Mina säljdistrikt';
            case 'salesdistrictsfoodservice':
                return 'Mina säljdistrikt foodservice';
            case 'statistics':
                return 'Min statistik';
            case 'watch':
                return 'Mina bevakningar';
            default: 
                return '';
        }
    }

    getText() {
        switch(this.state.type) {
            case 'register':
                return (
                    <>
                        <p>Som abonnent till Delfi Register har du möjlighet att söka och hitta information om våra butiker, kiosker, restauranger & storkök samt ladda hem information.</p>
                        <p>Besöksadress, Postadress, Kommun, Region, Omsättning, Telefon, Kontaktperson, Organisationsnummer, Juridiskt Namn, Lokaliseringskod EDI, Epost, Fax, Kedja, Kedjegrupp, Kassor, Säljyta, Storleksklass, Grossist, Sortiment, Öppettider, Karta Geografisk information, Longitud, Latitud</p>
                        <p>Kontakta oss för att ansluta dig till tjänsten: <a href="mailto:info@delfi.se">info@delfi.se</a></p>
                    </>
            );
            case 'salesdistricts':
                return (
                    <>
                        <p>Utnyttjar du dina säljresurser fullt ut? Med Delfis verktyg för säljdistriktsplanering, optimerar ni er säljkårs geografiska distrikt för att uppnå högre effektivitet och bättre resultat. Med enkla och användarvänliga kartfunktioner kan ni själva skapa era säljdistrikt med direkt tillgång till Delfis kundregister med aktuell information.</p>
                        <p>Kontakta oss för att ansluta dig till tjänsten: <a href="mailto:info@delfi.se">info@delfi.se</a></p>
                    </>
                );
            case 'salesdistrictsfoodservice':
                return (
                    <>
                        <p>Utnyttjar du dina säljresurser fullt ut? Med Delfis verktyg för säljdistriktsplanering Foodservice, optimerar ni er säljkårs geografiska distrikt för att uppnå högre effektivitet och bättre resultat. Med enkla och användarvänliga kartfunktioner kan ni själva skapa era säljdistrikt med direkt tillgång till Delfis kundregister med aktuell information.</p>
                        <p>Kontakta oss för att ansluta dig till tjänsten: <a href="mailto:info@delfi.se">info@delfi.se</a></p>
                    </>
                );
            case 'statistics':
                return (
                    <>
                        <p>Som abonnent till Delfi Statistik kan du följa branschens utveckling.</p>
                        <p>För att leverantörerna ska kunna följa utvecklingen på sina marknader erbjuder Delfi Marknadspartner försäljningsstatistik i olika former. Vi mäter mer än 150 varuslag inom marknader som t ex bryggeri, vin, choklad och konfektyr men även allmän branschutveckling för såväl foodservice- som för retailsektorn.</p>
                        <p>Kontakta oss för att ansluta dig till tjänsten: <a href="mailto:info@delfi.se">info@delfi.se</a></p>
                    </>
                );
            case 'watch':
                return (
                    <>
                        <p>Som abonnent till Delfi Register får du möjlighet att bevaka och följa enheter.</p>
                        <p>Kontakta oss för att få veta mer om tjänsten: <a href="mailto:info@delfi.se">info@delfi.se</a></p>
                    </>
                );
            default: 
                return '';
        }
    }

    render() {
        
        const props = this.props;

        return (
            <section className={classNames({
                'my-delfi': true,
                'my-delfi--is-loading': props.isLoading,
            })}>
                <div className="my-delfi__wrapper">
                    <div className="my-delfi__content">
                        {/*<h1 className="my-delfi__heading">Hej {props.menu && props.menu.loggedInUser}, välkommen till Delfi!</h1>*/}
                        <div className="my-delfi__navigation">
                            {props.registerBlock &&
                                <div className="my-delfi__box">
                                    <Link to="/search" className="my-delfi__box-inner my-delfi__box-inner--register">        
                                        <span className="my-delfi__box-link">Mitt Delfiregister</span>
                                    </Link>
                                </div>
                            }
                            {props.salesDistrictBlock &&
                                <div className="my-delfi__box">
                                    <Link to="/scenario" className="my-delfi__box-inner my-delfi__box-inner--position">
                                        <span className="my-delfi__box-link">Mina säljdistrikt</span>
                                    </Link>
                                </div>
                            }
                            {props.salesDistrictFoodserviceBlock &&
                                <div className="my-delfi__box">
                                    <Link to="/foodservice-scenario" className="my-delfi__box-inner my-delfi__box-inner--position">        
                                        <span className="my-delfi__box-link">Mina säljdistrikt foodservice</span>
                                    </Link>
                                </div>
                            }
                            {props.statisticsBlock &&
                                <div className="my-delfi__box">
                                    <Link to="/company" className="my-delfi__box-inner my-delfi__box-inner--stats">
                                        <span className="my-delfi__box-link">Min statistik</span>
                                    </Link>                            
                                </div>
                            }

                            <div className="my-delfi__box">
                                <Link to="/publications" className="my-delfi__box-inner my-delfi__box-inner--publications">
                                    <span className="my-delfi__box-link">Analyser & Insikter</span>
                                </Link>
                            </div>
    
                            {props.watcherBlock &&
                                <div className="my-delfi__box">
                                    <Link to="/myfeed" className="my-delfi__box-inner my-delfi__box-inner--star">        
                                        <span className="my-delfi__box-link">Mina bevakningar</span>
                                    </Link>
                                </div>
                            }
    
    
                            {!props.registerBlock &&
                                <div className="my-delfi__box my-delfi__box--no-access">
                                    <div onClick={() => this.toggleInfoAccount('register')} className="my-delfi__box-inner my-delfi__box-inner--register">        
                                        <span className="my-delfi__box-link">Mitt Delfiregister</span>
                                    </div>
                                </div>
                            }
                            {!props.salesDistrictBlock &&
                                <div className="my-delfi__box my-delfi__box--no-access">
                                    <div onClick={() => this.toggleInfoAccount('salesdistricts')} className="my-delfi__box-inner my-delfi__box-inner--position">
                                        <span className="my-delfi__box-link">Mina säljdistrikt</span>
                                    </div>
                                </div>
                            }
                            {!props.salesDistrictFoodserviceBlock &&
                                <div className="my-delfi__box my-delfi__box--no-access">
                                    <div onClick={() => this.toggleInfoAccount('salesdistrictsfoodservice')} className="my-delfi__box-inner my-delfi__box-inner--position">        
                                        <span className="my-delfi__box-link">Mina säljdistrikt foodservice</span>
                                    </div>
                                </div>
                            }
                            {!props.statisticsBlock &&
                                <div className="my-delfi__box my-delfi__box--no-access">
                                    <div onClick={() => this.toggleInfoAccount('statistics')} className="my-delfi__box-inner my-delfi__box-inner--stats">
                                        <span className="my-delfi__box-link">Min statistik</span>
                                    </div>                            
                                </div>
                            }
    
                            {!props.watcherBlock &&
                                <div className="my-delfi__box my-delfi__box--no-access">
                                    <div onClick={() => this.toggleInfoAccount('watch')} className="my-delfi__box-inner my-delfi__box-inner--star">        
                                        <span className="my-delfi__box-link">Mina bevakningar</span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <Takeover isOpen={this.state.isOpen} toggleTakeover={() => this.toggleInfoAccount('')} heading={this.getHeading()}>
                    
                    {this.getText()}
                    {/*
                    <div className="districts__takeover-controls">
                        <a href="mailto:info@delfi.se" className="districts__takeover-controls-btn districts__takeover-controls-btn--outline">Boka demo</a>
                    </div>*/}
                </Takeover>
                <SpinnerDots />
            </section>
        );
    }
};

export default MyDelfi;